<template>
  <div v-if="fileSrc" class="uploaded-image">
    <div class="row">
      <div class="col-sm-12 col-md-7">
        <img
          v-if="fileSrc"
          :src="fileSrc"
          class="img-fluid"
          :class="{ is_pdf: pdfCheck }"
        />
      </div>
      <div class="col-sm-12 col-md-5 flexright">
        <p class="txt">{{ fileName }}</p>
        <button class="btn-delete" @click.prevent="removeImagFile($event)">
          削除する
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { getFileSrcToBase64, getFileType } from "@/utils/ImageHelper";
export default {
  name: "UploadedImage",
  props: {
    fileName: { type: String, default: "" },
    fileData: { type: String, default: "" },
  },
  computed: {
    fileSrc: function () {
      return getFileSrcToBase64(this.fileData, this.fileName);
    },
    pdfCheck() {
      return getFileType(this.fileName) === "pdf";
    },
  },
  methods: {
    removeImagFile: function (event) {
      this.$emit("onDelete", event);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/styles";
.uploaded-image {
  background-color: $light;
  border: 1px solid $secondary;
  padding: 40px;
  .flexright {
    @include flex(flex, space-between, flex-start, column, nowrap);
    > .txt {
      word-break: break-all;
    }
  }
}
.is_pdf {
  max-width: inherit;
}
.btn-delete {
  background-color: $white;
  border: 1px solid $secondary;
  color: $black;
  width: 100%;
  text-align: center;
  cursor: pointer;
  padding: 12px 20px;
  display: inline-block;
  border-radius: 25px;
  font-size: 14px;
  > .pc {
    display: none;
  }
  > .sp {
    display: inline;
    line-height: 20px;
    > .icon {
      width: 18px;
      margin-right: 3px;
    }
  }
  @include mq-up(md) {
    font-size: 16px;
    .pc {
      display: inline;
    }
    .sp {
      display: none;
    }
  }
  &:hover {
    background-color: $light;
  }
  input {
    display: none;
  }
}
</style>
